import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import SetupGuide from 'cio/models/setup-guide';
import SetupGuideChannelsPushController from 'cio/pods/setup-guide/channels/push/controller';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';

export default class SetupGuideChannelsPush extends Route {
  crumb() {
    return {
      name: 'Push',
      path: 'setup-guide.channels.push',
    };
  }

  setupController(controller: SetupGuideChannelsPushController, model: SetupGuide, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.push.loadCredentials.perform();
    controller.setDefaults();
  }

  redirect(model: SetupGuide) {
    if (model.messagingChannelTypes.includes(MessagingChannelType.Push)) {
      return;
    }

    this.router.transitionTo('setup-guide.channels');
  }
}
